import { singleton } from 'tsyringe';

@singleton()
export class SplashService {
    public removeSplash() {
        document.getElementById('splash')?.classList.add('remove');
        setTimeout(() => document.getElementById('splash')?.remove(), 500);
    }
}
